module.exports = __webpack_public_path__ + "static/media/silk.0b5808c2.png";